import { RadioGroup, RadioButton } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { PITCH_CROP } from '@/consts/visualisations';
import { useSetQueryParams } from '@/hooks/queryParams/useSetQueryParams';
import { useSelectedVisualisationCrop } from '@/hooks/usePitchCrop';
import { ConfigDisplaySettingKey } from '@/types/userConfigs';
import { snakeToCamel } from '@/utils/queries';

export const PitchCropOptions = () => {
  const { t } = useTranslation('visualisation');
  // the user sees the swapped crop under Events Against, but the stored crop stays in the For frame
  const { visibleCrop: selectedPitchCrop, toStoredCrop } = useSelectedVisualisationCrop();

  const setQueryParams = useSetQueryParams();

  return (
    <RadioGroup groupId="pitch-crop-group" groupTitle={t('crop.pitchCrop')} size="regular">
      {PITCH_CROP.map(cropName => (
        <RadioButton
          key={cropName}
          checked={cropName === selectedPitchCrop}
          onChange={() => setQueryParams(ConfigDisplaySettingKey.PITCH_CROP, toStoredCrop(cropName))}
          id={`option-${cropName}`}
          label={t(`crop.${snakeToCamel(cropName.toLocaleLowerCase())}`)}
          value={cropName}
          size="small"
        />
      ))}
    </RadioGroup>
  );
};
